import { gql, useMutation } from "@apollo/client";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";

type CreateConfigItemDialogProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  mutation: ReturnType<typeof gql>;
  mutationName: string;
  redirectPath?: string;
};

const CreateConfigItemDialog = ({
  open,
  onClose,
  title,
  mutation,
  mutationName,
  redirectPath,
}: CreateConfigItemDialogProps) => {
  const [name, setName] = useState("");
  const navigate = useNavigate();

  const close = () => {
    setName("");
    onClose();
  }

  const [createItem, { loading }] = useMutation(mutation, {
    onCompleted: (data) => {
      if (redirectPath) {
        navigate(`${redirectPath}/${data[mutationName].id}`);
      }
      close();
    },
  });

  const handleSubmit = useCallback(async () => {
    if (!name.trim()) return;

    await createItem({
      variables: {
        name: name.trim(),
      },
      refetchQueries: ["OrgConfig"],
    });
  }, [name, createItem]);

  return (
    <Dialog open={open} onClose={close} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Name"
          type="text"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
          disabled={loading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={close} disabled={loading}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} disabled={loading || !name.trim()}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateConfigItemDialog; 